import { getApiBaseUrl } from "@apps/dashboard/lib/env";

const authBase = () => `${getApiBaseUrl().replace(/\/+$/, "")}/api/auth`;

export interface AuthSessionRow {
  id: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
  token: string;
  ipAddress?: string | null;
  userAgent?: string | null;
}

async function parseJson(res: Response): Promise<unknown> {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return null;
  }
}

function messageFromPayload(payload: unknown): string | undefined {
  if (!payload || typeof payload !== "object") return undefined;
  const o = payload as Record<string, unknown>;
  const m = o.message;
  return typeof m === "string" && m.length > 0 ? m : undefined;
}

export async function fetchAuthSessions(): Promise<AuthSessionRow[]> {
  const res = await fetch(`${authBase()}/list-sessions`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(messageFromPayload(payload) ?? `HTTP ${res.status}`);
  }
  if (!Array.isArray(payload)) {
    throw new Error("Invalid sessions response");
  }
  return payload as AuthSessionRow[];
}

export async function revokeAuthSessionToken(token: string): Promise<void> {
  const res = await fetch(`${authBase()}/revoke-session`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(messageFromPayload(payload) ?? `HTTP ${res.status}`);
  }
}

export async function revokeOtherAuthSessions(): Promise<void> {
  const res = await fetch(`${authBase()}/revoke-other-sessions`, {
    method: "POST",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(messageFromPayload(payload) ?? `HTTP ${res.status}`);
  }
}
